export const tool = "ai-image-generator";
export const frameCostPerImage = 5;

export const maxImageCount = 4;
export const orientations = ["square", "landscape", "portrait"] as const;

export function aspectData(orientation: (typeof orientations)[number]) {
  if (orientation === "square") {
    return {
      ratioText: "1:1",
      height: 768,
      width: 768,
    };
  }

  if (orientation === "landscape") {
    return {
      ratioText: "16:9",
      width: 1024,
      height: 576,
    };
  }

  return {
    ratioText: "9:16",
    width: 576,
    height: 1024,
  };
}
